import { LOADING, MEETING_TYPES } from "../actionType/meetingType";

const initialState = {
  loading: false,
  meetingTypes: [],
};

const meetingTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case MEETING_TYPES:
      return { ...state, meetingTypes: payload };
    case LOADING:
      return { ...state, loading: payload };
    default:
      return state;
  }
};

export default meetingTypeReducer;
